import { Pick } from "model/Pickem/Pickem";
import { PointsPartition } from "model/PickemDetails/PointsPartition";
import { MessageBox } from "styles/text";
import { RankemGridRow } from "./RankemGridRow";
import { selectRosterDisplayName } from "selectors/Roster";
import { useAppSelector } from "app/hooks";

interface Props {
  tournamentId: string;
  columns: PointsPartition[];
  gridRosterIds: string[];
  picks: {
    [id: string]: Pick;
  };
  updatePick: (rosterId: string, position: number | undefined) => void;
  frozenRosters: { [id: string]: number };
}

export const RankemGrid = ({
  tournamentId,
  columns,
  gridRosterIds,
  picks,
  updatePick,
  frozenRosters,
}: Props) => {
  const frozenRosterIds = Object.keys(frozenRosters);
  const frozenPositions = Object.values(frozenRosters);
  const gridPicks: { [teamId: string]: Pick } = {};
  Object.keys(picks).forEach((rosterId) => {
    if (gridRosterIds.includes(rosterId)) {
      gridPicks[rosterId] = picks[rosterId];
    }
  });

  // todo - extract to be reusable
  useAppSelector((state) =>
    gridRosterIds.sort((a, b) =>
      (selectRosterDisplayName(state, a, tournamentId) ?? "").localeCompare(
        selectRosterDisplayName(state, b, tournamentId) ?? ""
      )
    )
  );

  return (
    <>
      {frozenRosterIds.length > 0 && (
        <MessageBox
          style={{
            textAlign: "center",
            margin: "5px auto",
            marginBottom: "10px",
            maxWidth: "600px",
          }}
        >
          One or more picks are frozen
        </MessageBox>
      )}
      <table style={{ margin: "auto" }}>
        {gridRosterIds.map((rosterId) => (
          <RankemGridRow
            columns={columns}
            rosterId={rosterId}
            tournamentId={tournamentId}
            frozen={frozenRosterIds.includes(rosterId)}
            frozenPositions={frozenPositions}
            gridPicks={gridPicks}
            updatePick={updatePick}
          />
        ))}
      </table>
    </>
  );
};
